import { BRANDS } from "app/constants";

const SAUDIA_BASE_URLS = [
	"sv.live.perfectstay.io",
	"svum.live.perfectstay.io",
	"svso.live.perfectstay.io",
];

export const getDomain = (baseUrl = "") => {
	const isSaudiaDomain = SAUDIA_BASE_URLS.some(domain => baseUrl?.includes(domain));

	return isSaudiaDomain ? "https://www.saudia.com" : baseUrl;
};

// Single source of truth for the canonical URL of the current page.
export const getCanonicalUrl = ({
	brand,
	shop,
	baseUrl,
	proxyBasenamePrefix = "",
	pathname = "",
	queryParam = "",
}) => {
	const computedPathname = pathname === "/" ? "" : pathname;
	const domain = getDomain(baseUrl);

	return brand === BRANDS.PS && shop !== "fr-FR"
		? `https://booking.perfectstay.com/${shop}${computedPathname}`
		: `${domain}${proxyBasenamePrefix}/${shop}${computedPathname}${queryParam}`;
};

// Homepage URL with a trailing slash (used for Organization.url and the "Home" breadcrumb item).
export const getHomeUrl = params => {
	const url = getCanonicalUrl({ ...params, pathname: "/" });

	return url.endsWith("/") ? url : `${url}/`;
};
